import UserModel from 'models/User';
import CompanyModel from 'models/Company';
import messageSlice from 'redux/messageSlice';
import store from 'redux/store';

import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_USER,
  SET_COMPANY
} from "../actions/types";
import CookieHelper from "helpers/cookie";
	let user = new UserModel();
	let company = new CompanyModel();
	
	let rawCookie = CookieHelper.getCookie("mmev_obj");
	let userToken = false;
	if(typeof rawCookie != 'undefined') {
		let tokenObj = JSON.parse(rawCookie);
		if (tokenObj && tokenObj.token) {
			userToken = tokenObj.token;
		}
	}

//const user = null;
if(window.mmev) {
//	user = window.mmev.mmev_token.user;
}
const initialState = userToken
  ? { isLoggedIn: true, userToken, user: user, company: company }
  : { isLoggedIn: false, userToken: null, user: null, company: null };
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_USER:
		user = new UserModel();
		user.addData( payload.user );
		console.log( "set user", user );
		company = new CompanyModel();
		company.addData( payload.user.company );
      return {
        ...state,
        isLoggedIn: true,
        user: user,
		company: company
      };

    case SET_COMPANY:
		company = new CompanyModel();
		company.addData( payload.company );

      return {
        ...state,
        isLoggedIn: true,
        user: user,
		company: company
      };
	
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
		user.addData( payload.user );
		company.addData( payload.user.company );
		state.user = user;
		if(typeof window.auth == 'function') {
			window.auth(LOGIN_SUCCESS, payload);
		}
      return {
        ...state,
        isLoggedIn: true,
        user: user,
		company: company,
		token: payload.token
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
		company: null
      };
    case LOGOUT:
		user = new UserModel();
			var date = new Date();
			date.setTime(date.getTime()+(-12*60*60*1000));
			CookieHelper.setCookie("mmev_obj", "", date.getTime()/ 1000 );

			if(typeof window.auth == 'function') {
				window.auth(LOGOUT);
			}
			state.user = null;
			state.userToken = null;
      return {
        ...state,
        isLoggedIn: false,
        user: null,
		company: null
      };
    default:
       return {
        ...state,
        user: user,
		company: company
      };
 }
}